import { render, staticRenderFns } from "./StepInsurance.vue?vue&type=template&id=60a5d3bc"
import script from "./StepInsurance.vue?vue&type=script&lang=js"
export * from "./StepInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports